var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ColorBar__Container"},[_c('section',{staticClass:"ColorBar"},_vm._l((_vm.toolSwatches),function(swatch,index){return _c('div',{key:swatch.id},[_c('div',{staticClass:"Swatch",class:{ 'Swatch--active': swatch.isActive && ['chalk'].includes(_vm.activeTool.id) },style:({
          background: `url(${require(`@/assets/img/textures/chalk_${index+1}.png`)})`,
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }),on:{"click":function($event){return _vm.onSwatchClick(swatch)}}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }